"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQueryParamValue = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url-search-params.js");

/**
 * @name useQueryParamValue
 * @description Returns a boolean value indicating whether the specified query parameter value
 * exists in the current URL's search parameters.
 * @param {string} param - The name of the query parameter to search for.
 * @param {string} value - The value of the query parameter to search for.
 * @returns {boolean} - Returns true if the specified query parameter value exists in the
 * current URL's search parameters; otherwise, false.
 */
var useQueryParamValue = function useQueryParamValue(param, value) {
  if (typeof window === 'undefined') return false;
  var queryString = window.location.search;
  var searchParams = new URLSearchParams(queryString);
  return searchParams.has(param) && searchParams.get(param) === value;
};

exports.useQueryParamValue = useQueryParamValue;